import { getNumberOfDecimalPlaces } from './chunk-CVLY5S52.js';
import { isMediaStream, isHLSSrc } from './chunk-FRNAFKFA.js';
import { IS_SAFARI } from './chunk-KKTONNDY.js';
import { isUndefined, isNumber, setAttribute, isString, useDisposalBin, listenEvent, DOMEvent, isNil } from 'maverick.js/std';
import { onDispose } from 'maverick.js';

var RAFLoop = class {
  constructor(_callback) {
    this.ga = _callback;
  }
  eb() {
    if (!isUndefined(this.va))
      return;
    this.Vc();
  }
  fa() {
    if (isNumber(this.va))
      window.cancelAnimationFrame(this.va);
    this.va = void 0;
  }
  Vc() {
    this.va = window.requestAnimationFrame(() => {
      if (isUndefined(this.va))
        return;
      this.ga();
      this.Vc();
    });
  }
};

// src/player/core/providers/html/html–media-events.ts
var HTMLMediaEvents = class {
  constructor(_provider, _context) {
    this.i = _provider;
    this.c = _context;
    this.$ = useDisposalBin();
    this.Pa = false;
    this.Wc = false;
    this.Xc = false;
    this.fb = new RAFLoop(this.oe.bind(this));
    this.Ie = void 0;
    this.Fh = void 0;
    this.pe();
    onDispose(this.Jb.bind(this));
  }
  get a() {
    return this.i.media;
  }
  get j() {
    return this.c.delegate;
  }
  Jb() {
    this.fb.fa();
    this.$.empty();
  }
  /**
   * The `timeupdate` event fires surprisingly infrequently during playback, meaning your progress
   * bar (or whatever else is synced to the currentTime) moves in a choppy fashion. This helps
   * resolve that by retrieving time updates in a request animation frame loop.
   */
  oe() {
    const newTime = this.i.currentTime;
    if (this.c.$store.currentTime() !== newTime)
      this.Qa(newTime);
  }
  pe() {
    this.r("loadstart", this.ha);
    this.r("abort", this.Yc);
    this.r("emptied", this.qe);
    this.r("error", this.ia);
  }
  re() {
    if (this.Wc)
      return;
    this.$.add(
      this.r("loadeddata", this.se),
      this.r("loadedmetadata", this.te),
      this.r("canplay", this.gb),
      this.r("canplaythrough", this.ue),
      this.r("durationchange", this.ve),
      this.r("play", this.we),
      this.r("progress", this.xe),
      this.r("stalled", this.ye),
      this.r("suspend", this.ze)
    );
    this.Wc = true;
  }
  Ae() {
    if (this.Xc)
      return;
    this.$.add(
      this.r("pause", this.Be),
      this.r("playing", this.Ce),
      this.r("ratechange", this.De),
      this.r("seeked", this.Ee),
      this.r("seeking", this.Fe),
      this.r("ended", this.Ge),
      this.r("volumechange", this.Kb),
      this.r("waiting", this.He)
    );
    this.Xc = true;
  }
  r(eventType, handler) {
    return listenEvent(
      this.a,
      eventType,
      handler.bind(this)
    );
  }
  Gh(event2) {
    return;
  }
  Qa(time, trigger) {
    this.j.d("time-update", {
      // Avoid errors where `currentTime` can have higher precision.
      detail: {
        currentTime: Math.min(time, this.c.$store.seekableEnd()),
        played: this.a.played
      },
      trigger
    });
  }
  ha(event2) {
    if (this.a.networkState === 3) {
      this.Yc(event2);
      return;
    }
    this.re();
    this.j.d("load-start", { trigger: event2 });
  }
  Yc(event2) {
    this.j.d("abort", { trigger: event2 });
  }
  qe() {
    this.j.d("emptied", { trigger: event });
  }
  se(event2) {
    this.j.d("loaded-data", { trigger: event2 });
  }
  te(event2) {
    this.Je();
    this.Ae();
    this.j.d("volume-change", {
      detail: {
        volume: this.a.volume,
        muted: this.a.muted
      }
    });
    this.j.d("loaded-metadata", { trigger: event2 });
    if (IS_SAFARI && isHLSSrc(this.c.$store.source())) {
      this.j.Zc(this.Lb(), event2);
    }
  }
  Lb() {
    return {
      duration: this.a.duration,
      buffered: this.a.buffered,
      seekable: this.a.seekable
    };
  }
  Je() {
    if (this.c.$store.streamType() !== "unknown")
      return;
    const isLive = !Number.isFinite(this.a.duration);
    this.j.d("stream-type-change", {
      detail: isLive ? "live" : "on-demand"
    });
  }
  we(event2) {
    if (!this.c.$store.canPlay)
      return;
    this.j.d("play", { trigger: event2 });
  }
  Be(event2) {
    if (this.a.readyState === 1 && !this.Pa)
      return;
    this.Pa = false;
    this.fb.fa();
    this.j.d("pause", { trigger: event2 });
  }
  gb(event2) {
    this.j.Zc(this.Lb(), event2);
  }
  ue(event2) {
    if (this.c.$store.started())
      return;
    this.j.d("can-play-through", {
      trigger: event2,
      detail: this.Lb()
    });
  }
  Ce(event2) {
    this.Pa = false;
    this.j.d("playing", { trigger: event2 });
    this.fb.eb();
  }
  ye(event2) {
    this.j.d("stalled", { trigger: event2 });
    if (this.a.readyState < 3) {
      this.Pa = true;
      this.j.d("waiting", { trigger: event2 });
    }
  }
  He(event2) {
    if (this.a.readyState < 3) {
      this.Pa = true;
      this.j.d("waiting", { trigger: event2 });
    }
  }
  Ge(event2) {
    this.fb.fa();
    this.Qa(this.a.duration, event2);
    this.j.d("end", { trigger: event2 });
    if (this.c.$store.loop()) {
      this.Ke();
    } else {
      this.j.d("ended", { trigger: event2 });
    }
  }
  ve(event2) {
    if (this.c.$store.ended()) {
      this.Qa(this.a.duration, event2);
    }
    this.j.d("duration-change", {
      detail: this.a.duration,
      trigger: event2
    });
  }
  Kb(event2) {
    this.j.d("volume-change", {
      detail: {
        volume: this.a.volume,
        muted: this.a.muted
      },
      trigger: event2
    });
  }
  Ee(event2) {
    this.Qa(this.a.currentTime, event2);
    this.j.d("seeked", {
      detail: this.a.currentTime,
      trigger: event2
    });
    if (Math.trunc(this.a.currentTime) === Math.trunc(this.a.duration) && getNumberOfDecimalPlaces(this.a.duration) > getNumberOfDecimalPlaces(this.a.currentTime)) {
      this.Qa(this.a.duration, event2);
      if (!this.a.ended) {
        this.c.player.dispatchEvent(
          new DOMEvent("media-play-request", {
            trigger: event2
          })
        );
      }
    }
  }
  Fe(event2) {
    this.j.d("seeking", {
      detail: this.a.currentTime,
      trigger: event2
    });
  }
  xe(event2) {
    this.j.d("progress", {
      detail: {
        buffered: this.a.buffered,
        seekable: this.a.seekable
      },
      trigger: event2
    });
  }
  Ke() {
    const hasCustomControls = isNil(this.a.controls);
    if (hasCustomControls)
      this.a.controls = false;
    this.c.player.dispatchEvent(new DOMEvent("media-loop-request"));
  }
  ze(event2) {
    this.j.d("suspend", { trigger: event2 });
  }
  De(event2) {
    this.j.d("rate-change", {
      detail: this.a.playbackRate,
      trigger: event2
    });
  }
  ia(event2) {
    const error = this.a.error;
    if (!error)
      return;
    this.j.d("error", {
      detail: {
        message: error.message,
        code: error.code,
        mediaError: error
      },
      trigger: event2
    });
  }
};

// src/foundation/list/symbols.ts
var LIST_ADD = Symbol(0);
var LIST_REMOVE = Symbol(0);
var LIST_RESET = Symbol(0);
var LIST_SELECT = Symbol(0);
var LIST_READONLY = Symbol(0);
var LIST_SET_READONLY = Symbol(0);
var LIST_ON_RESET = Symbol(0);
var LIST_ON_REMOVE = Symbol(0);
var LIST_ON_USER_SELECT = Symbol(0);

// src/player/core/providers/html/native-audio-tracks.ts
var NativeAudioTracks = class {
  constructor(_provider, _context) {
    this.i = _provider;
    this.c = _context;
    this.Ra.onaddtrack = this.Le.bind(this);
    this.Ra.onremovetrack = this.Me.bind(this);
    this.Ra.onchange = this.Ne.bind(this);
    listenEvent(this.c.audioTracks, "change", this.Oe.bind(this));
  }
  get Ra() {
    return this.i.media.audioTracks;
  }
  Le(event2) {
    const _track = event2.track;
    if (_track.label === "")
      return;
    const audioTrack = {
      id: _track.id + "",
      label: _track.label,
      language: _track.language,
      kind: _track.kind,
      selected: false
    };
    this.c.audioTracks[LIST_ADD](audioTrack, event2);
    if (_track.enabled)
      audioTrack.selected = true;
  }
  Me(event2) {
    const track = this.c.audioTracks.getById(event2.track.id);
    if (track)
      this.c.audioTracks[LIST_REMOVE](track, event2);
  }
  Ne(event2) {
    let enabledTrack = this._c();
    if (!enabledTrack)
      return;
    const track = this.c.audioTracks.getById(enabledTrack.id);
    if (track)
      this.c.audioTracks[LIST_SELECT](track, true, event2);
  }
  _c() {
    return Array.from(this.Ra).find((track) => track.enabled);
  }
  Oe(event2) {
    const { current } = event2.detail;
    if (!current)
      return;
    const track = this.Ra.getTrackById(current.id);
    if (track) {
      const prev = this._c();
      if (prev)
        prev.enabled = false;
      track.enabled = true;
    }
  }
};

// src/player/core/providers/html/provider.ts
var HTMLMediaProvider = class {
  constructor(_media) {
    this.a = _media;
  }
  setup(context) {
    new HTMLMediaEvents(this, context);
    if ("audioTracks" in this.media)
      new NativeAudioTracks(this, context);
  }
  get type() {
    return "";
  }
  get media() {
    return this.a;
  }
  get paused() {
    return this.a.paused;
  }
  get muted() {
    return this.a.muted;
  }
  set muted(muted) {
    this.a.muted = muted;
  }
  get volume() {
    return this.a.volume;
  }
  set volume(volume) {
    this.a.volume = volume;
  }
  get currentTime() {
    return this.a.currentTime;
  }
  set currentTime(time) {
    this.a.currentTime = time;
  }
  get playsinline() {
    return this.a.hasAttribute("playsinline");
  }
  set playsinline(playsinline) {
    setAttribute(this.a, "playsinline", playsinline);
  }
  get playbackRate() {
    return this.a.playbackRate;
  }
  set playbackRate(rate) {
    this.a.playbackRate = rate;
  }
  async play() {
    return this.a.play();
  }
  async pause() {
    return this.a.pause();
  }
  async loadSource({ src }, preload) {
    this.a.preload = preload;
    if (isMediaStream(src)) {
      this.a.srcObject = src;
    } else {
      this.a.srcObject = null;
      this.a.src = isString(src) ? src : window.URL.createObjectURL(src);
    }
    this.a.load();
  }
};

export { HTMLMediaProvider, LIST_ADD, LIST_ON_REMOVE, LIST_ON_RESET, LIST_ON_USER_SELECT, LIST_READONLY, LIST_REMOVE, LIST_RESET, LIST_SELECT, LIST_SET_READONLY, RAFLoop };
